module.exports = __webpack_public_path__ + "static/media/Brownies _ Blondies.42e76057.jpg";